import React, { useEffect } from "react";

import { epocToDate } from "utils";

function ZebraDatePicker(props) {
  useEffect(() => {
    const $dateRef = window.$("#" + props.idRef);

    $dateRef.Zebra_DatePicker({
      format: "m-d-Y",
      onSelect: handleChange,
      direction: props.inputProps.direction,
      show_clear_date: false
    });

    $dateRef.val(epocToDate(props.inputProps.value, "MM-dd-yyyy"));

    return () => {
      $dateRef.Zebra_DatePicker("destroy");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  function handleChange(value) {
    props.onChange(value);
  }

  return (
    <div className="input_text_wrap">
      <span className="Zebra_DatePicker_Icon_Wrapper">
        <input
          type="text"
          id={props.idRef}
          className="input_text"
          placeholder="From Date"
          readOnly="readonly"
        />
      </span>
      <span className="icon" />{" "}
    </div>
  );
}

export default ZebraDatePicker;
